export enum NotificationEnum {
  APPROVE_SUCCESS = "Approve successfully!",
  APPROVE_ERROR = "Approve failed!",
  POOL_EXIST = "Pool already exists",
  CREATE_TOKEN_SUCCESS = "Create token successfully!",
  CREATE_TOKEN_FAILED = "Can not create token",
  EXIST_TOKEN = "Token has been created"
}
